import { addSpaceRegex } from '../../../util/string-util';
import { Numeracao } from '../../dispositivo/numeracao';
import { TipoDispositivo } from '../tipo/tipoDispositivo';
import { isNumeracaoValida, trataComplemento } from './numeracaoUtil';

export function NumeracaoItem<TBase extends Constructor>(Base: TBase): any {
  return class extends Base implements Numeracao {
    type = 'NumeracaoItemLcp95';
    private SUFIXO = '.';
    numero?: string;
    rotulo?: string;

    private normalizaNumeracao(numero: string): string {
      const num = /\d+(-[a-zA-Z]+)*/.exec(numero.trim());
      return num ? num[0] : addSpaceRegex(numero).trim().replace(/\.$/, '').trim();
    }

    createNumeroFromRotulo(rotulo: string): void {
      const temp = this.normalizaNumeracao(rotulo!);
      this.numero = isNumeracaoValida(temp) ? temp : undefined;
    }

    createRotulo(): void {
      this.rotulo = this.numero === undefined ? TipoDispositivo.item.name : trataComplemento(this.numero) + this.SUFIXO;
    }

    getNumeracaoParaComandoEmenda(): string {
      if (this.numero === undefined) {
        return TipoDispositivo.item.descricao?.toLowerCase() + '';
      }
      return trataComplemento(this.numero);
    }

    getNumeracaoComRotuloParaComandoEmenda(): string {
      if (this.numero === undefined) {
        return TipoDispositivo.item.descricao?.toLocaleLowerCase() + '';
      }
      return TipoDispositivo.item.descricao?.toLocaleLowerCase() + ' ' + this.getNumeracaoParaComandoEmenda();
    }
  };
}
